import { useQuery } from '@tanstack/react-query';

import { fetchReport } from 'features/reports/hooks/useReport/useReport.queries';
import { UseReport } from 'features/reports/hooks/useReport/useReport.types';
import { useReportMutations } from 'features/reports/hooks/useReport/useReportMutations';

export const useReport = (reportId: number): UseReport => {
  const { isReportUpdating, onDeleteReport, onUpdateReport } =
    useReportMutations(reportId);

  const {
    data: report,
    error,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ['report', reportId],
    queryFn: () => fetchReport(reportId),
    enabled: Boolean(reportId),
  });

  return {
    isReportInError: isError,
    isReportLoading: isLoading,
    isReportUpdating,
    onDeleteReport,
    onUpdateReport,
    report,
    reportFetchError: error,
  };
};
